import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IconComponent } from '@outlaw/icons';
import type { IconName } from '@outlaw/icons';

@Component({
  selector: 'outlaw-subscribe-button',
  styleUrls: ['./subscribe-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <button class="community-button subscribe" [class.free-video]="isFreeVideo()" (click)="onSubscribeClick($event)">
      <outlaw-icon class="icon-svg" [name]="subscribeIcon()" />
      {{ subscribeLabel() }}
    </button>
  `,
})
export class SubscribeButtonComponent {
  readonly isFreeVideo = input<boolean>(false);
  readonly subscribeClick = output<Event>();

  readonly subscribeLabel = computed<string>(() =>
    this.isFreeVideo() ? 'Register to watch for free' : 'Subscribe to watch'
  );

  readonly subscribeIcon = computed<IconName>(() => (this.isFreeVideo() ? 'majiSign' : 'ticket'));

  onSubscribeClick(event: Event): void {
    event.stopPropagation();
    this.subscribeClick.emit(event);
  }
}
